import { createApp, h } from 'vue'
import { createI18n } from 'vue-i18n'
import singleSpaVue from 'single-spa-vue'

import App from './App.vue'
import store from './store'
import router, { whiteList } from './router'
import es from './locales/es'

import {
  DataWrapper,
  TextWrapper,
  NoData,
  InProgress,
  Permission,
  PermissionUtils,
  VueGtmUtils,
} from '@azimut-mfe/styleguide'
import { Amplify } from 'aws-amplify'

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolClientId: process.env.VUE_APP_COGNITO_CLIENT_ID,
      userPoolId: process.env.VUE_APP_COGNITO_POOL_ID,
      identityPoolId: process.env.AWS_DEFAULT_REGION,
    },
  },
})

const i18n = createI18n({
  allowComposition: true,
  locale: 'es',
  messages: {
    es: {
      ...es.messages,
    },
  },
  dateTimeFormats: {
    es: es.dateTimeFormats,
  },
  numberFormats: {
    es: es.numberFormats,
  },
})

const vueLifecycles = singleSpaVue({
  createApp,
  appOptions: {
    render() {
      return h(App, {})
    },
  },
  handleInstance: (app) => {
    app.use(router)
    app.use(
      VueGtmUtils.createGtm({
        id: process.env.VUE_APP_GTM_ID,
        vueRouter: router,
      })
    )
    PermissionUtils.registerRouterListeners(router, whiteList)
    app.use(store)
    app.use(i18n)
    app.component('DataWrapper', DataWrapper)
    app.component('TextWrapper', TextWrapper)
    app.component('NoData', NoData)
    app.component('InProgress', InProgress)
    app.component('Permission', Permission)
  },
})

export const bootstrap = vueLifecycles.bootstrap
export const mount = vueLifecycles.mount
export const unmount = vueLifecycles.unmount
